/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  GetUniversityQueryResponse,
  GetUniversityPathParams,
  GetUniversity404,
} from '../types/GetUniversity'

function getGetUniversityUrl({
  university_id,
}: {
  university_id: GetUniversityPathParams['university_id']
}) {
  const res = {
    method: 'GET',
    url: `/api/v1/universities/${university_id}/` as const,
  }
  return res
}

/**
 * @summary Get university detail
 * {@link /api/v1/universities/:university_id/}
 */
export async function getUniversity(
  {
    university_id,
  }: { university_id: GetUniversityPathParams['university_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GetUniversityQueryResponse,
    ResponseErrorConfig<GetUniversity404>,
    unknown
  >({
    method: 'GET',
    url: getGetUniversityUrl({ university_id }).url.toString(),
    ...requestConfig,
  })
  return res.data
}
